import { PresenceBadges } from "../../../components/presence-badges";
import { useCanvasViewersStore } from "../store/canvas-viewers-store";

// 右上：参加ユーザー一覧。
// useCanvasViewersStore の viewers を購読してリアルタイム更新する。
export function PresenceList(): JSX.Element {
  const viewers = useCanvasViewersStore((s) => s.viewers);
  const list = Object.values(viewers);
  return (
    <div
      style={{
        position: "absolute",
        top: "16px",
        right: "16px",
        zIndex: 10,
      }}
    >
      <PresenceBadges viewers={list} />
    </div>
  );
}
